import $ from 'jquery'
import { load } from '../../utils/ajax'
import { format } from '../../utils/currency'
import IMask from 'imask'

const maskOptions = {
  mask: Number,
  scale: 2,
  signed: false,
  thousandsSeparator: ' ',
  radix: '.',
  mapToRadix: [','],
  normalizeZeros: false
}

class Module {
  constructor ($module) {
    this.$container = $module
    this.$totalAmount = $module.find('.js-total_amount')
    this.currency = $module.data('currency')
    this.$transferAmount = $module.find('.js-transfer_amount')
    this.transferAmount = new IMask(this.$transferAmount.get(0), maskOptions)
    this.$transferAmountGroup = this.$transferAmount.closest('.form-group')
    this.xhr = null
    
    const self = this
    
    this.$transferAmount.on('change keyup', function () {
      self.$totalAmount.html('...')
      self.$transferAmountGroup.addClass('loading')
      
      if (self.xhr) {
        self.xhr.abort()
      }
      
      self.xhr = load(self.$container.data('calc-url'),
        { transfer_amount: self.transferAmount.unmaskedValue },
        function (response) {
          self.$totalAmount.html(format(response.data.amount, self.currency))
          self.$transferAmountGroup.removeClass('loading')
        })
    }).trigger('change')
  }
}

$(function () {
  $('.js-account_refund').each(function () {
    new Module($(this))
  })
})
